__turbopack_context__.v({
  "bottomBar": "global-footer-module-scss-module__vAqsWa__bottomBar",
  "contact": "global-footer-module-scss-module__vAqsWa__contact",
  "footer": "global-footer-module-scss-module__vAqsWa__footer",
  "iconYoutube": "global-footer-module-scss-module__vAqsWa__iconYoutube",
  "info": "global-footer-module-scss-module__vAqsWa__info",
  "infoItems": "global-footer-module-scss-module__vAqsWa__infoItems",
  "link": "global-footer-module-scss-module__vAqsWa__link",
  "linkContainer": "global-footer-module-scss-module__vAqsWa__linkContainer",
  "links": "global-footer-module-scss-module__vAqsWa__links",
  "linksAndNewsletter": "global-footer-module-scss-module__vAqsWa__linksAndNewsletter",
  "locales": "global-footer-module-scss-module__vAqsWa__locales",
  "locationItems": "global-footer-module-scss-module__vAqsWa__locationItems",
  "locationTitle": "global-footer-module-scss-module__vAqsWa__locationTitle",
  "locations": "global-footer-module-scss-module__vAqsWa__locations",
  "logoLink": "global-footer-module-scss-module__vAqsWa__logoLink",
  "mainContent": "global-footer-module-scss-module__vAqsWa__mainContent",
  "navItem": "global-footer-module-scss-module__vAqsWa__navItem",
  "navItems": "global-footer-module-scss-module__vAqsWa__navItems",
  "navLink": "global-footer-module-scss-module__vAqsWa__navLink",
  "newsletter": "global-footer-module-scss-module__vAqsWa__newsletter",
  "socialItem": "global-footer-module-scss-module__vAqsWa__socialItem",
  "socialItemIcon": "global-footer-module-scss-module__vAqsWa__socialItemIcon",
  "socialLink": "global-footer-module-scss-module__vAqsWa__socialLink",
  "title": "global-footer-module-scss-module__vAqsWa__title",
});
